import { defHttp, getApiUrlByDomain } from '/@/utils/http/axios';
import {
  LoginParams,
  LoginResultModel,
  GetUserInfoModel,
  RefreshParams,
  SinUpParams,
  resetPassParams,
  LoginIdsParams,
  LoginIdsResult,
  CheckAndGetAccountsParams,
} from './model/userModel';

import { ErrorMessageMode, Result, UploadFileParams } from '/#/axios';

export enum UserApi {
  Login = '/member/tokens',
  Logout = '/logout',
  GetUserInfo = '/member/login-accounts/profiles',
  GetPermCode = '/getPermCode',
  TestRetry = '/testRetry',
  TestToken = '/member/login-accounts/profiles',
  RefreshToken = '/member/tokens',
  SinUp = '/member/login-accounts',
  // 发送邮箱验证码
  SendEmailCode = '/member/login-accounts/password/otp',
  // 验证邮箱验证码
  VerifyEmailCode = '/member/login-accounts/password/otp/verification',
  // 重置密码
  ResetPassword = '/member/login-accounts/password/reset',
  GetVerifyCode = '/member/captcha/get-captcha',
  VerifySlideCode = '/member/captcha/check-captcha',
  RegisterSendEmailCode = '/member/login-accounts/otp',
  // 获取logIn id list
  GetLoginIdList = '/member/login-accounts/password/reset/available-login-accounts',
  /* 修改用户信息 start*/
  //修改账号信息
  UpdateAccount = '/member/login-accounts/profiles/update',
  //修改密码
  UpdatePassword = '/member/login-accounts/password/update',
  //修改密码-发送邮箱验证码
  UpdatePasswordSendEmailCode = '/member/login-accounts/password/update/otp',
  //修改密码-验证验证码
  UpdatePasswordVerifyEmailCode = '/member/login-accounts/password/update/otp/verification',
  // 上传用户头像
  UploadAvatar = '/member/login-accounts/profiles/avatar/upload',
  // 获取用户头像
  GetAvatar = '/member/login-accounts/profiles/avatar',
  /* 修改用户信息 end*/
  // 校验用户填写的邮箱或loginId，获取可用的loginId
  CheckAndGetAccounts = '/member/login-accounts/available-usernames',
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'message') {
  return defHttp.post<LoginResultModel>(
    {
      url: UserApi.Login,
      params,
    },
    {
      errorMessageMode: mode,
      isTransformResponse: false,
    },
  );
}

/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  return defHttp.get<GetUserInfoModel>(
    { url: UserApi.GetUserInfo },
    {
      errorMessageMode: 'none',
    },
  );
}

export function getPermCode() {
  return defHttp.get<string[]>({ url: UserApi.GetPermCode });
}

export function doLogout() {
  return defHttp.get({ url: UserApi.Logout });
}

export function testRetry() {
  return defHttp.get(
    { url: UserApi.TestRetry },
    {
      retryRequest: {
        isOpenRetry: true,
        count: 5,
        waitTime: 1000,
      },
    },
  );
}
export function testToken() {
  return defHttp.get({ url: UserApi.TestToken });
}

export function refreshTokenApi(params: RefreshParams) {
  return defHttp.post(
    {
      url: UserApi.RefreshToken,
      params,
    },
    {
      isTransformResponse: false,
    },
  );
}
export function SinUp(params: SinUpParams) {
  return defHttp.post(
    {
      url: UserApi.SinUp,
      params,
    },
    {
      errorMessageMode: 'message',
    },
  );
}

export function SendEmailCode(params: Partial<resetPassParams>) {
  return defHttp.post(
    {
      url: UserApi.SendEmailCode,
      params,
    },
    {
      errorMessageMode: 'message',
    },
  );
}

export function VerifyEmailCode(params: Partial<resetPassParams>) {
  return defHttp.post(
    {
      url: UserApi.VerifyEmailCode,
      params,
    },
    {
      errorMessageMode: 'message',
    },
  );
}
export function GetLoginIdList(params: Partial<LoginIdsParams>) {
  return defHttp.post<LoginIdsResult>(
    {
      url: UserApi.GetLoginIdList,
      params,
    },
    {
      errorMessageMode: 'message',
    },
  );
}
export function ResetPassword(params: Partial<resetPassParams>) {
  return defHttp.post(
    {
      url: UserApi.ResetPassword,
      params,
    },
    {
      errorMessageMode: 'message',
    },
  );
}

//获取验证图片  以及token
export function GetVerifyCode(data) {
  return defHttp.post(
    {
      url: UserApi.GetVerifyCode,
      data,
    },
    {
      errorMessageMode: 'modal',
      isTransformResponse: false,
    },
  );
}

//滑动或者点选验证
export function VerifySlideCode(data) {
  return defHttp.post(
    {
      url: UserApi.VerifySlideCode,
      data,
    },
    {
      errorMessageMode: 'modal',
      isTransformResponse: false,
    },
  );
}

export function RegisterSendEmail(data) {
  return defHttp.post(
    {
      url: UserApi.RegisterSendEmailCode,
      data,
    },
    {
      errorMessageMode: 'message',
    },
  );
}

//修改密码
export function UpdatePasswordApi(params: Partial<resetPassParams>) {
  return defHttp.post(
    {
      url: UserApi.UpdatePassword,
      params,
    },
    {
      errorMessageMode: 'message',
      isTransformResponse: false,
    },
  );
}

//滑动或者点选验证
export function getUpdatePasswordSendEmailCode(data) {
  return defHttp.post(
    {
      url: UserApi.UpdatePasswordSendEmailCode,
      data,
    },
    {
      errorMessageMode: 'message',
      isTransformResponse: false,
    },
  );
}

export function UpdatePasswordVerifyEmailCodeApi(data) {
  return defHttp.post(
    {
      url: UserApi.UpdatePasswordVerifyEmailCode,
      data,
    },
    {
      errorMessageMode: 'message',
      isTransformResponse: false,
    },
  );
}

/**
 * [更新账号信息](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E7%99%BB%E9%99%86%E8%B4%A6%E5%8F%B7/updateProfiles)
 */
export const updateProfiles = (
  params: Partial<Pick<GetUserInfoModel, 'firstname' | 'lastname'>>,
) => {
  return defHttp.post<boolean>(
    {
      url: UserApi.UpdateAccount,
      params,
    },
    {
      errorMessageMode: 'message',
    },
  );
};

/**
 * [上传用户头像](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E7%99%BB%E9%99%86%E8%B4%A6%E5%8F%B7/uploadAvatar)
 */
export const uploadAvatar = (params: UploadFileParams) => {
  const apiUrl = getApiUrlByDomain(window.location.href);
  return defHttp.uploadFile<Result<{ name: string; path: string }>>(
    {
      url: apiUrl + UserApi.UploadAvatar,
      timeout: 60 * 1000,
    },
    params,
  );
};

// 校验用户填写的邮箱或loginId，获取可用的loginId
export function CheckAndGetAccounts(data: Partial<CheckAndGetAccountsParams>) {
  return defHttp.post(
    {
      url: UserApi.CheckAndGetAccounts,
      data,
    },
    {
      errorMessageMode: 'message',
      withToken: false,
    },
  );
}
